<template>
  <span class="br-status" :class="`br-status--${statusKey}`">
    {{ getText() }}
  </span>
</template>

<script>
const STATUS_LABELS = {
  ACTIVE: "Ativo",
  PAID: "Pago",
  CONFIRMED: "Confirmado",
  CANCELED: "Cancelado",
  PENDING: "Pendente",
  PRE_REGISTRATION: "Pré-cadastro",
  PENDENT: "Pendente",
  WAITING: "Aguardando",
  BLOCKED: "Bloqueado",
};

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },

  computed: {
    statusKey() {
      const key = String(this.status || "").toUpperCase();
      if (["ACTIVE", "PAID", "CONFIRMED"].includes(key)) return "success";
      if (["CANCELED", "BLOCKED"].includes(key)) return "danger";
      if (["PENDING", "PRE_REGISTRATION", "PENDENT"].includes(key)) return "warning";
      if (key === "WAITING") return "info";
      return "neutral";
    },
  },

  methods: {
    getText() {
      const key = String(this.status || "").toUpperCase();
      return STATUS_LABELS[key] || this.status;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/design-system/tokens";

.br-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 11px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.2px;
  line-height: 1.3;
  white-space: nowrap;
}

.br-status--success {
  color: $br-success-dark;
  background: rgba(36, 168, 89, 0.14);
}

.br-status--danger {
  color: $br-brand-dark;
  background: rgba(229, 24, 61, 0.12);
}

.br-status--warning {
  color: $br-warning-dark;
  background: rgba(217, 119, 6, 0.14);
}

.br-status--info {
  color: $br-navy;
  background: rgba(36, 41, 104, 0.12);
}

.br-status--neutral {
  color: $br-muted;
  background: rgba(92, 100, 133, 0.12);
}
</style>
